export const ERROR_CODE_SEARCH_PARAM = 'errorCode';
